<template>
  <div>
    <change-password :userId="userId"> </change-password>
  </div>
</template>
<script>
import ChangePassword from "@/components_rms/System/User/ChangePassword.vue";
export default {
    name: "UserChangePassword",
  components: {
    ChangePassword,
  },
  props: {
    userId: String,
  },
};
</script>
